import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "signup": "Sign Up",
          "signin": "Sign In",
          "signin-already-have-account": "Already have an account?",
          "signin-with-google": "Sign In with Google",
          "signin-no-account": "No Account?",
          "signin-forgot-password": "Forgot Password?",
          "update-profile": "Update Profile",
          "become-tourguide": "Become a Guide",
          "search-go": "Go!",
          "search-random": "Random",
          "search-placeholder": "Search Destinations",

          "home-hero-title": "Your local adventure awaits",
          "home-hero-subtitle": "Connect with independent tour guides who bring authentic local experiences to life",
          "home-signup-ad": "Join as a tour guide, share your passion, meet travelers from around the world, and earn on your own terms.",

          "location-experiences-guided-tours": "Available Tours",
          "location-no-experiences": "No tours available at this location yet. Check back soon!",
          "location-no-information": "Location not found. Please try another destination.",

          "tourguide-get-started": "Create Your Guide Profile",
          "tourguide-get-started-paragraph": "Set up your profile to start offering tours and connecting with travelers.",
          "tourguide-create-guide-profile": "Get Started",
          "tourguide-dashboard": "Dashboard",
          "tourguide-my-tours": "My Tours",
          "tourguide-schedule": "Schedule",
          "tourguide-profile": "Profile",
          "tourguide-create-tour": "Create Tour",
          "tourguide-no-tours": "You haven't created any tours yet. Start by creating your first tour!",

          "tour-title": "Tour Title",
          "tour-description": "Description",
          "tour-duration": "Duration (hours)",
          "tour-cost": "Price",
          "tour-cost-type": "Pricing Type",
          "tour-max-size": "Max Group Size",
          "tour-per-person": "Per Person",
          "tour-per-tour": "Per Tour",
          "tour-create": "Create Tour",
          "tour-update": "Save Changes",
          "tour-delete": "Delete Tour",
          "tour-schedule": "Schedule Dates",

          "schedule-title": "Schedule Tour",
          "schedule-add-date": "Add Date",
          "schedule-date": "Date & Time",
          "schedule-capacity": "Available Spots",
          "schedule-no-dates": "No dates scheduled yet. Add your first available date!",

          "footer-about": "About",
          "footer-safety": "Safety",
          "footer-privacy": "Privacy",
          "footer-socials": "Connect",
          "footer-tagline": "Authentic local experiences, one tour at a time.",
        }
      },
      it: {
        translation: {
          "signup": "Registrati",
          "signin": "Accedi",
          "signin-already-have-account": "Hai già un account?",
          "signin-with-google": "Accedi con Google",
          "signin-no-account": "Nessun account?",
          "signin-forgot-password": "Password dimenticata?",
          "update-profile": "Aggiorna profilo",
          "become-tourguide": "Diventa una Guida",
          "search-go": "Vai!",
          "search-random": "Casuale",
          "search-placeholder": "Cerca destinazioni",

          "home-hero-title": "La tua avventura locale ti aspetta",
          "home-hero-subtitle": "Connettiti con guide turistiche indipendenti che portano in vita esperienze locali autentiche",
          "home-signup-ad": "Unisciti come guida turistica, condividi la tua passione, incontra viaggiatori da tutto il mondo e guadagna alle tue condizioni.",

          "location-experiences-guided-tours": "Tour Disponibili",
          "location-no-experiences": "Nessun tour disponibile in questa posizione. Torna presto!",
          "location-no-information": "Posizione non trovata. Prova un'altra destinazione.",

          "tourguide-get-started": "Crea il Tuo Profilo Guida",
          "tourguide-get-started-paragraph": "Configura il tuo profilo per iniziare a offrire tour e connetterti con i viaggiatori.",
          "tourguide-create-guide-profile": "Inizia",
          "tourguide-dashboard": "Dashboard",
          "tourguide-my-tours": "I Miei Tour",
          "tourguide-schedule": "Programma",
          "tourguide-profile": "Profilo",
          "tourguide-create-tour": "Crea Tour",
          "tourguide-no-tours": "Non hai ancora creato nessun tour. Inizia creando il tuo primo tour!",

          "tour-title": "Titolo del Tour",
          "tour-description": "Descrizione",
          "tour-duration": "Durata (ore)",
          "tour-cost": "Prezzo",
          "tour-cost-type": "Tipo di Prezzo",
          "tour-max-size": "Dimensione Massima Gruppo",
          "tour-per-person": "Per Persona",
          "tour-per-tour": "Per Tour",
          "tour-create": "Crea Tour",
          "tour-update": "Salva Modifiche",
          "tour-delete": "Elimina Tour",
          "tour-schedule": "Programma Date",

          "schedule-title": "Programma Tour",
          "schedule-add-date": "Aggiungi Data",
          "schedule-date": "Data e Ora",
          "schedule-capacity": "Posti Disponibili",
          "schedule-no-dates": "Nessuna data programmata. Aggiungi la tua prima data disponibile!",

          "footer-about": "Chi Siamo",
          "footer-safety": "Sicurezza",
          "footer-privacy": "Privacy",
          "footer-socials": "Connettiti",
          "footer-tagline": "Esperienze locali autentiche, un tour alla volta.",
        }
      },
      es: {
        translation: {
          "signup": "Regístrarse",
          "signin": "Iniciar sesión",
          "signin-already-have-account": "¿Ya tienes una cuenta?",
          "signin-with-google": "Iniciar sesión con Google",
          "signin-no-account": "¿No tienes una cuenta?",
          "signin-forgot-password": "¿Olvidaste tu contraseña?",
          "update-profile": "Actualizar perfil",
          "become-tourguide": "Sé un Guía",
          "search-go": "¡Ir!",
          "search-random": "Aleatorio",
          "search-placeholder": "Buscar destinos",

          "home-hero-title": "Tu aventura local te espera",
          "home-hero-subtitle": "Conéctate con guías turísticos independientes que dan vida a experiencias locales auténticas",
          "home-signup-ad": "Únete como guía turístico, comparte tu pasión, conoce viajeros de todo el mundo y gana en tus propios términos.",

          "location-experiences-guided-tours": "Tours Disponibles",
          "location-no-experiences": "No hay tours disponibles en esta ubicación todavía. ¡Vuelve pronto!",
          "location-no-information": "Ubicación no encontrada. Por favor, intenta otro destino.",

          "tourguide-get-started": "Crea Tu Perfil de Guía",
          "tourguide-get-started-paragraph": "Configura tu perfil para empezar a ofrecer tours y conectar con viajeros.",
          "tourguide-create-guide-profile": "Comenzar",
          "tourguide-dashboard": "Panel",
          "tourguide-my-tours": "Mis Tours",
          "tourguide-schedule": "Horario",
          "tourguide-profile": "Perfil",
          "tourguide-create-tour": "Crear Tour",
          "tourguide-no-tours": "Aún no has creado ningún tour. ¡Empieza creando tu primer tour!",

          "tour-title": "Título del Tour",
          "tour-description": "Descripción",
          "tour-duration": "Duración (horas)",
          "tour-cost": "Precio",
          "tour-cost-type": "Tipo de Precio",
          "tour-max-size": "Tamaño Máximo del Grupo",
          "tour-per-person": "Por Persona",
          "tour-per-tour": "Por Tour",
          "tour-create": "Crear Tour",
          "tour-update": "Guardar Cambios",
          "tour-delete": "Eliminar Tour",
          "tour-schedule": "Programar Fechas",

          "schedule-title": "Programar Tour",
          "schedule-add-date": "Añadir Fecha",
          "schedule-date": "Fecha y Hora",
          "schedule-capacity": "Plazas Disponibles",
          "schedule-no-dates": "No hay fechas programadas. ¡Añade tu primera fecha disponible!",

          "footer-about": "Acerca de",
          "footer-safety": "Seguridad",
          "footer-privacy": "Privacidad",
          "footer-socials": "Conectar",
          "footer-tagline": "Experiencias locales auténticas, un tour a la vez.",
        }
      }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
